'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { useState } from 'react';
import { Alert, Button, Col, Container, Form, Row } from 'reactstrap';
import { logSentryError } from '../../utils/logSentry';
import ThankyouMailingImage from '../svg/ThankyouMailing';
import { saveCandidate } from '../../api/candidate';
import { Dictionaries } from '../../i18n/i18n-config';
import { getI18nUtils } from '../../i18n/i18n-utils';

const SubscribeSection = ({ dictionary }: { dictionary: Partial<Dictionaries> }): JSX.Element => {
  const { formatMessage } = getI18nUtils(dictionary);
  const [errorAlert, setErrorAlert] = useState<string | null>(null);

  const [completed, setCompleted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function submitHandler(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await saveCandidate({ receiveMatchmail: true }, 'email');
      setCompleted(true);
    } catch (err) {
      logSentryError(err);
      setErrorAlert('email-settings-update-error');
    }
    setSubmitting(false);
  }

  return (
    <Container>
      <Row>
        <Col md={{ size: 5 }} className="d-flex justify-content-center align-items-center">
          <ThankyouMailingImage />
        </Col>
        <Col md={{ size: 7, order: 1 }} className="d-flex flex-column justify-content-center align-items-start p-5">
          <Form>
            <fieldset disabled={submitting}>
              <div className="mx-xl-5 px-lg-5">
                <h2 className="mb-3" style={{ textTransform: 'none' }}>
                  {formatMessage({ id: 'thankyou_mailing_title' })}{' '}
                </h2>
                {completed ? (
                  <Alert color="success">{formatMessage({ id: 'thankyou_mailingsubscription' })}</Alert>
                ) : (
                  <>
                    <p>{formatMessage({ id: 'thankyou_mailing_proposition' })}</p>
                    <Button color="primary" onClick={(e) => submitHandler(e)}>
                      {formatMessage({ id: 'thankyou_subscribe' })}
                    </Button>
                  </>
                )}

                {errorAlert && (
                  <Alert isOpen={!!errorAlert} color="danger" className="mt-3">
                    {formatMessage({ id: errorAlert })}
                  </Alert>
                )}
              </div>
            </fieldset>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default SubscribeSection;
